/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CorrectRecordingRequestEditsInnerDupIsrcsInner
 */
export interface CorrectRecordingRequestEditsInnerDupIsrcsInner {
    /**
     * Recording ID the ISRC is being reassigned from
     * @type {string}
     * @memberof CorrectRecordingRequestEditsInnerDupIsrcsInner
     */
    dupRecordingId: string;
    /**
     * OpenSearch document ID of the source recording
     * @type {string}
     * @memberof CorrectRecordingRequestEditsInnerDupIsrcsInner
     */
    dupDocumentId: string;
}

/**
 * Check if a given object implements the CorrectRecordingRequestEditsInnerDupIsrcsInner interface.
 */
export function instanceOfCorrectRecordingRequestEditsInnerDupIsrcsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "dupRecordingId" in value;
    isInstance = isInstance && "dupDocumentId" in value;

    return isInstance;
}

export function CorrectRecordingRequestEditsInnerDupIsrcsInnerFromJSON(json: any): CorrectRecordingRequestEditsInnerDupIsrcsInner {
    return CorrectRecordingRequestEditsInnerDupIsrcsInnerFromJSONTyped(json, false);
}

export function CorrectRecordingRequestEditsInnerDupIsrcsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CorrectRecordingRequestEditsInnerDupIsrcsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dupRecordingId': json['dup_recording_id'],
        'dupDocumentId': json['dup_document_id'],
    };
}

export function CorrectRecordingRequestEditsInnerDupIsrcsInnerToJSON(value?: CorrectRecordingRequestEditsInnerDupIsrcsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dup_recording_id': value.dupRecordingId,
        'dup_document_id': value.dupDocumentId,
    };
}

